import CountryPageRenderer from '../components/CountryPageRenderer';
import spainData from '../data/country-pages/spain';

export default function SpainCountryPage() {
  return <CountryPageRenderer data={spainData} />;
}
